import { createFileRoute, useSearch } from "@tanstack/react-router";
import { AdminSignUp } from "~/components/Admin/AdminSignUp";
import { PlainTopPanel } from "~/components/Layout/PlainTopPanel";
import { createCredentialAccount } from "~/lib/server-functions/create-credential-account";

type SignUpSearch = {
  company?: string;
  salutation?: "frau" | "herr" | "divers";
  firstName?: string;
  lastName?: string;
  email?: string;
  pendingEmailToken?: string;
  /** Path to redirect to after sign-in (e.g. /add-location) */
  redirect?: string;
};

export const Route = createFileRoute("/advertiser/_blank/sign-up")({
  validateSearch: (search: Record<string, unknown>): SignUpSearch => {
    // validate and parse the search params into a typed state
    return {
      company: typeof search.company === "string" ? search.company : undefined,
      salutation:
        search.salutation === "frau" ||
          search.salutation === "herr" ||
          search.salutation === "divers"
          ? search.salutation
          : undefined,
      firstName:
        typeof search.firstName === "string" ? search.firstName : undefined,
      lastName:
        typeof search.lastName === "string" ? search.lastName : undefined,
      email: typeof search.email === "string" ? search.email : undefined,
      pendingEmailToken:
        typeof search.pendingEmailToken === "string"
          ? search.pendingEmailToken
          : undefined,
      redirect:
        typeof search.redirect === "string" && search.redirect.startsWith("/")
          ? search.redirect
          : undefined,
    };
  },
  component: RouteComponent,
  beforeLoad: ({ search }) => {
    if (!search.pendingEmailToken) return;

    createCredentialAccount({ data: { token: search.pendingEmailToken } });
  },
});

function RouteComponent() {
  const search = useSearch({ from: "/advertiser/_blank/sign-up" });
  return (
    <>
      <PlainTopPanel />
      <div className="relative h-[calc(100vh-var(--top-panel-height))]">
        <img
          src="/temp/sign-up-background.jpg"
          alt=""
          className="absolute inset-0 object-cover w-full h-full"
        />
        <div className="layout-content-grid grid place-items-center w-full h-full overflow-auto z-10 relative py-4">
          <AdminSignUp
            className="w-full max-w-[560px] relative z-0 mx-auto"
            redirectAfterSignUp={search.redirect}
          />
        </div>
      </div>
    </>
  );
}
